module.exports = __webpack_public_path__ + "c578efb16efc55a66b1ae0f5c6d193b8.png";